<template>
  <veaDialog
    title="导出周报"
    class="showZB"
    :show.sync="show"
    :before-close="closeDialogZB"
  >
    <el-date-picker
      v-model="ZBbded"
      type="daterange"
      range-separator="-"
      value-format="yyyy-MM-dd"
      format="yyyy-MM-dd"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
    >
    </el-date-picker>
  </veaDialog>
</template>

<script>
import { GetZhouBaoRp } from '@api/api.js'
export default {
  props: {
    pautoid: {
      // 传入的autoid
      type: String,
      default: ''
    }
  },
   data() {
      return {
        userInfo: JSON.parse(sessionStorage.userInfo) || {},
        show: false,
        ZBbded: null
      }
    },
  methods: {
   
    closeDialogZB(a) {
      if (a == 'confirm') {
        if (this.ZBbded != null) {
          const bd = this.ZBbded[0]
          const ed = this.ZBbded[1]

          GetZhouBaoRp({
            crman: this.userInfo.name,
            bd,
            ed,
            autoid: this.pautoid || this.$route.query.autoid
          }).then(res => {
            if (res.error == '0') {
              this.show = false
              window.open(res.list[0].ssourl, '_blank')
            } else {
              this.$message.error(res.errorinfo)
            }
          })
        } else {
          this.$message.error('请选择时间范围')
        }
      } else {
        this.show = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.showZB {
  /deep/ .el-dialog {
    width: 400px;
    .el-dialog__body {
      padding: 20px;
    }
  }
}
</style>
